import { Controller } from '@hotwired/stimulus'
import { useDebounce } from "stimulus-use"
import "select2"
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static debounces = ['onListingRowInputChange', 'onSeedSupplierInputChange']
  static targets = ['UpdatedAtText', 'NewItemForm', 'ErrorContainer']

  connect() {
    useDebounce(this)
    this.element[this.identifier] = this

    $(".select2").select2({
      allowClear: true,
      tags: true,
      placeholder: "Select or type in"
    });

    $(".edit_listing :input").on('input', (e) => {
      this.onListingRowInputChange(e)
    })

    $("#edit-seed-supplier :input").on('input', (e) => {
      this.onSeedSupplierInputChange(e)
    })
  }

  onNewListingClick(e) {
    e.target.classList.add("hidden")
    this.NewItemFormTarget.classList.remove("hidden")

    setTimeout(() => {
      $(".select2").select2({
        allowClear: true,
        tags: true,
        placeholder: "Select or type in"
      })
    }, 250)
  }

  async onListingRowInputChange(e) {
    var formData = new FormData(e.target.form)
    var row = $(e.target.form).closest("tr")

    $(row)[0].classList.add("bg-yellow-100")

    const url = e.target.form.action
    for (var pair of formData.entries()) {
      console.log(pair[0]+ ', ' + pair[1]);
    }
    const request = new FetchRequest('PATCH', url, { body: formData, responseKind: 'json' } )
    const response = await request.perform()

    if (response.ok) {
      let responseJson = await response.json
      var updatedAt = responseJson.updated_at
      if (this.hasUpdatedAtTextTarget) {
        this.UpdatedAtTextTarget.innerHTML = updatedAt
      }

      $(row).removeClass("bg-red-100")
      $(row).removeClass("bg-yellow-100")
      $(row).addClass("bg-green-100")
      this.ErrorContainerTarget.innerHTML = ""
      this.ErrorContainerTarget.classList.add("hidden")

      setTimeout(() => {
        $(row).removeClass("bg-green-100")
      }, 1000)
    } else {
      let error = await response.json
      console.log('error: ', error)
      $(row).removeClass("bg-yellow-100")
      $(row).addClass("bg-red-100")
      this.ErrorContainerTarget.innerHTML = error.errors.full_messages.join(", ")
      this.ErrorContainerTarget.classList.remove("hidden")
    }
  }

  onSeedSupplierInputChange(e) {
    var formData = $(e.target.form).serialize()
    $(e.target).addClass("bg-yellow-100")

    Rails.ajax({
      url: e.target.form.action,
      type: "PATCH",
      dataType: 'json',
      data: formData,
      success: (response) => {
        var updatedAt = response.updated_at
        if (this.hasUpdatedAtTextTarget) {
          this.UpdatedAtTextTarget.innerHTML = updatedAt
        }

        $(e.target).removeClass("bg-yellow-100")
        $(e.target).addClass("bg-green-100")

        setTimeout(() => {
          $(e.target).removeClass("bg-green-100")
        }, 1000)
      },
      error: (error) => {
        console.log('error: ', error)
        $(e.target).removeClass("bg-yellow-100")
        $(e.target).addClass("bg-red-100")
      }
    })
  }

  onTheirPriceChange(e) {
    var row = $(e.target.form).closest("tr")

    let isSeedSupplier = true
    var species = $(row).find(".species-value").html()
    let dealerPrice = $(e.target).val()
    let authToken = "impossible_to_guess_cce_and_h85_auth_token_yeah_right_you_wont_guess_it_ill_keep_going"

    fetch(`/api/markup_price?retail_supplier=${isSeedSupplier}&species=${species}&price_per=${dealerPrice}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${authToken}`
      }
    })
      .then(response => response.json())
      .then(response => {
        let markedupValue = response.price.toFixed(3)
        var markupContainer = $(row).find(".auto-markup-container")
        markupContainer.text("$" + markedupValue)
        markupContainer[0].classList.remove("hidden")
      })
      .catch(console.error)
  }

}
